import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { Form, Button, Dropdown, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from "react-quill";
import JoditEditor from "jodit-react";
import EditorConfig from "./EditorConfig";
import Select from "react-select";
import "react-quill/dist/quill.snow.css";
import { BASE_URL, security_key } from "../../../global";
import LinearProgress from "@mui/material/LinearProgress";

const RichTextEditor = {
    modules: {
        toolbar: [
            [{ header: "1" }, { header: "2" }, { font: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["bold", "italic", "underline"],
            [{ align: [] }],
            // ["link", "image"],
            ["clean"],
        ],
    },
    formats: ["header", "font", "list", "bullet", "bold", "italic", "underline", "align", "link", "image", "clean"],
};

const AddArticleForm = () => {
    const [loading, setLoading] = useState(true);
    const [showPreview, setShowPreview] = useState(false);
    const navigate = useNavigate();
    const formRef = useRef(null);
    const newTagRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [categoryOption, setCategoryOption] = useState([]);
    const [subcategories, setsubCategories] = useState([]);

    // const [magazineOption, setMagazineOption] = useState([{ value: "562FF5E4CB9AC181", label: "Paperboy" }]);
    const [magazineOption, setMagazineOption] = useState([]);
    const [statusOption, setStatusOption] = useState([
        { value: 1, label: "Draft" },
        { value: 2, label: "Published" },
        { value: 3, label: "Archived" },
    ]);

    const editor = useRef(null);

    useEffect(() => {
        getAllCategory();
        getAllMagazine();
        fetchAllSubCategory();
    }, []);

    const getAllCategory = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllCategory",
        });

        const output = response.data;

        if (output.length > 0) {
            setCategoryOption(
                output.map((option) => ({
                    value: option.pk_cat_key,
                    label: option.cat_name,
                }))
            );
        }
    };

    const getAllMagazine = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllMagForPost",
        });

        const output = response.data;

        if (output.length > 0) {
            setMagazineOption(
                output.map((option) => ({
                    value: option.pk_mag_key,
                    label: option.mag_name,
                }))
            );
        }
    };

    const initialValues = {
        ac_name: "",
        ac_summary: "",
        additionalFields: [
            {
                type: "image/video",
                value: "",
                // accept: "image/*",
                accept: "image/*,video/*",
            },
            {
                type: "multimedia",
                value: "",
            },
        ],
        newFieldType: "",
        created_by: sessionStorage.getItem("pk_user_key"),
        visibility: 1,
        tags: [],
        newTag: "",
        // status: "draft",
        status: 1,
        // fk_mag_key: "562FF5E4CB9AC181",
        fk_mag_key: "",
        category: [],
        subcategories: {},
    };

    const imageFileSchema = Yup.mixed()
        .required("A file is required for image or video.")
        .test("fileSize", "The file is too small.", (value) => {
            if (value && value[0]) {
                const img = new Image();
                img.src = URL.createObjectURL(value[0]);
                return new Promise((resolve) => {
                    img.onload = () => {
                        // Set your desired dimensions
                        const minWidth = 800;
                        const minHeight = 600;
                        if (img.width >= minWidth && img.height >= minHeight) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    };
                });
            }
            return false; // No file provided
        });

    const validationSchema = Yup.object().shape({
        ac_name: Yup.string()
            .required("Article Name is required.")
            .test("no-leading-space", "No spaces allowed at the beginning.", function (value) {
                if (!value) return true;
                return !/^\s/.test(value);
            })
            .min(3, "Article Name must be at least 3 characters.")
            .max(100, "Article Name must be at most 100 characters.")
            .test("no-trailing-space", "No spaces allowed at the end.", function (value) {
                if (!value) return true;
                return !/\s$/.test(value);
            })
            // .matches(
            //     /^[a-zA-Z0-9'.,%:;\s-]+$/,
            //     "The input should only contain letters, numbers, spaces, and common punctuation (apostrophes, periods, commas, colons, semicolons, hyphens, and percentage symbols), and should not start or end with a space or special character."
            // )
            // .matches(/^[a-zA-Z][a-zA-Z\s]*[a-zA-Z]$/, "Article Name should only contain letters and spaces, and should not start or end with a space.")

            .test("unique-link", "Article Name is already existing in the database", async function (value) {
                if (!value) return true;
                const isArticleNameUnique = await checkArticleTitle(value);
                return isArticleNameUnique;
            }),
        ac_summary: Yup.string()
            .required("Article Summary is required.")
            .test("no-leading-space", "No spaces allowed at the beginning.", function (value) {
                if (!value) return true;
                return !/^\s/.test(value);
            })
            .min(90, "Article Summary must be at least 90 character.")
            .max(250, "Article Summary must be at most 250 characters.")
            // .matches(/^[^\s].*[^\s]$/, "Summary should not have leading or trailing spaces.")
            .test("no-trailing-space", "No spaces allowed at the end.", function (value) {
                if (!value) return true;
                return !/\s$/.test(value);
            }),

        additionalFields: Yup.array().of(
            Yup.object().shape({
                type: Yup.string().required("Field type is required."), // Ensure type is always specified
                value: Yup.string().when("type", {
                    is: (val) => val === "text" || val === "multimedia",
                    then: (schema) => schema.required("Content is required."),
                    otherwise: (schema) => schema.notRequired(),
                }),
                // fileType: Yup.string().when("type", {
                //     is: "image/video",
                //     then: (schema) => schema.required("File type is required for image or video."),
                //     otherwise: (schema) => schema.notRequired(),
                // }),
                file: Yup.mixed().when("type", {
                    is: "image/video",
                    then: (schema) => schema.required("A file is required for image or video."),
                    // then: (schema) => schema.required("Please upload an image with a minimum size of 300x300 pixels."),
                    // .test("fileSize", "Please upload an image with a minimum size of 300x300 pixels.", function (value) {
                    //     if (value && value.size) {
                    //         const img = new Image();
                    //         img.src = URL.createObjectURL(value);

                    //         return new Promise((resolve) => {
                    //             img.onload = () => {
                    //                 const { width, height } = img;
                    //                 if (width >= 300 && height >= 300) {
                    //                     resolve(true);
                    //                 } else {
                    //                     resolve(false);
                    //                 }
                    //             };
                    //             img.onerror = () => resolve(false);
                    //         });
                    //     }
                    //     return true; // No file, validation is handled by required above
                    // }),
                    otherwise: (schema) => schema.notRequired(),
                }),
            })
        ),
        tags: Yup.array().of(Yup.string()).default([]),
        newTag: Yup.string()
            .when("tags", (tags, schema) => {
                const flattenedTags = tags.flat().filter((tag) => tag !== "");
                if (flattenedTags.length === 0) {
                    return schema.required("Tag is required.");
                }
                return schema.notRequired();
            })
            .matches(/^[a-zA-Z0-9\s]*$/, "Tag can only contain letters and numbers."),

        status: Yup.string().required("Status is required."),
        fk_mag_key: Yup.string().required("Magazine is required."),
        category: Yup.array()
            .of(Yup.string().required("Category is required."))
            .min(1, "At least one category must be selected.")
            .required("Category is required."),
        // subcategories: Yup.object()
        //     .test(
        //         "subcategory-per-category",
        //         "Each selected category must have a subcategory selected.",
        //         function (selectedSubs) {
        //             const { category } = this.parent;

        //             if (!category || category.length === 0) return true;
        //             const categoriesWithSubs = category.filter((catId) =>
        //                 subcategories.some((s) => s.fk_cat_key === catId)
        //             );
        //             return categoriesWithSubs.every(
        //                 (catId) => selectedSubs && selectedSubs[catId]
        //             );
        //         }
        //     )
        //     .required("Subcategories are required."),
        subcategories: Yup.object().test(
            "valid-subcategories",
            "Invalid subcategory selection",
            function (selectedSubs) {
                if (!selectedSubs || Object.keys(selectedSubs).length === 0) {
                    return true; // allow empty
                }

                return true; // add optional validation here if needed
            }
        ),
    });

    async function checkArticleTitle(ac_name) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkArticleTitle",
            ac_name: ac_name,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (formValues) => {
            if (formValues.tags.length === 0) {
                formik.setFieldError("tags", "Please add at least one tag before submitting the article.");
                return;
            }
            toast.dismiss();
            setIsSubmitting(true);

            // setTimeout(() => {
            //     // setFieldValue("additionalFields", [
            //     // { type: "image/video", value: "", accept: "image/*" },
            //     // { type: "multimedia", value: "" },
            //     // ]);
            //     formik.resetForm();
            //     console.clear();
            //     console.log(formik.values);
            //     setIsSubmitting(false);
            //     formik.resetForm({
            //         values: {
            //             additionalFields: [
            //                 { type: "image/video", value: "", accept: "image/*" },
            //                 { type: "multimedia", value: "" },
            //             ],
            //         },
            //     });
            // }, 5000);

            try {
                const response = await axios.post(
                    `${BASE_URL}API/apicall`,
                    {
                        security_key,
                        mode: "addArticle1",
                        ...formValues,
                    },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                const output = response.data;
                if (output == 1) {
                    // resetFormFields();
                    formik.resetForm(); // Reset form directly
                    setFieldValue("additionalFields", [
                        { type: "image/video", value: "", accept: "image/*" },
                        { type: "multimedia", value: "" },
                    ]);
                    toast.success("Added successfully!", {
                        autoClose: 3000,
                    });

                    setTimeout(() => {
                        navigate("../article-management");
                    }, 3000);
                } else {
                    toast.error("Oops! Something went wrong.", {
                        autoClose: 3000,
                    });
                }
            } catch (error) {
                toast.error("Error adding article: " + error.message);
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    // const { values, handleBlur, touched, handleChange, errors, handleSubmit, setFieldValue, resetForm, setTouched } = formik;

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;

    const handleSubcategoryChange = (catId, selectedOption) => {
        setValues((prev) => ({
            ...prev,
            subcategories: {
                ...prev.subcategories,
                [catId]: selectedOption?.value || "", // save the subcategory id for that category
            },
        }));
    };

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    // const handleAddField = () => {
    //     if (values.newFieldType) {
    //         setFieldValue("additionalFields", [...values.additionalFields, { type: values.newFieldType, value: "", accept: "image/*,video/*" }]);
    //         setFieldValue("newFieldType", "");
    //     }
    // };

    const handleAddField = (fieldType) => {
        if (fieldType) {
            setFieldValue("additionalFields", [...values.additionalFields, { type: fieldType, value: "", accept: "image/*,video/*", isNew: true }]);
            setFieldValue("newFieldType", "");
        }
    };

    const handleRemoveField = (index) => {
        const updatedFields = values.additionalFields.filter((_, i) => i !== index);
        setFieldValue("additionalFields", updatedFields);
    };

    // const handleAddTag = () => {
    //     if (values.newTag && !values.tags.includes(values.newTag)) {
    //         setFieldValue("tags", [...values.tags, values.newTag]);
    //         setFieldValue("newTag", "");
    //     }
    // };
    const handleAddTag = () => {
        if (values.newTag && !values.tags.flat().includes(values.newTag)) {
            setFieldValue("tags", [...values.tags.flat(), values.newTag]); // Flatten to avoid nested arrays
            setFieldValue("newTag", "");
            if (newTagRef.current) {
                newTagRef.current.focus();
                newTagRef.current.blur();
            }
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        setFieldValue(
            "tags",
            values.tags.filter((tag) => tag !== tagToRemove)
        );
    };

    const handleFileChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
            const updatedFields = [...values.additionalFields];
            updatedFields[index] = {
                ...updatedFields[index],
                value: URL.createObjectURL(file),
                fileType: file.type,
                file: file,
            };
            setFieldValue("additionalFields", updatedFields);
        }
    };

    // const handleFileChange = (e, index) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const img = new Image();
    //         img.src = URL.createObjectURL(file);

    //         img.onload = () => {
    //             const { width, height } = img;
    //             const minWidth = 300; // Minimum width
    //             const minHeight = 300; // Minimum height

    //             if (width < minWidth || height < minHeight) {
    //                 // Set error message for image dimensions
    //                 setFieldValue(`errors.additionalFields[${index}].file`, `Please upload an image with a minimum size of ${minWidth}x${minHeight} pixels.`);
    //                 return;
    //             }

    //             // Clear any existing errors if the image is valid
    //             setFieldValue(`errors.additionalFields[${index}].file`, null);

    //             const updatedFields = [...values.additionalFields];
    //             updatedFields[index] = {
    //                 ...updatedFields[index],
    //                 value: URL.createObjectURL(file),
    //                 fileType: file.type,
    //                 file: file,
    //             };
    //             setFieldValue("additionalFields", updatedFields);
    //         };

    //         img.onerror = () => {
    //             // Handle image loading errors
    //             setFieldValue(`errors.additionalFields[${index}].file`, "Invalid image file.");
    //         };
    //     }
    // };

    // const handleFileChange = (e, index) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const fileWithMetadata = {
    //             file: file,
    //             file_id: index,
    //         };
    //         const updatedFields = [...values.additionalFields];
    //         updatedFields[index] = {
    //             ...updatedFields[index],
    //             value: URL.createObjectURL(file),
    //             fileType: file.type,
    //             file: fileWithMetadata,
    //         };
    //         setFieldValue("additionalFields", updatedFields);
    //     }
    // };

    useEffect(() => {
        console.clear();
        console.log(values);
        // console.log(errors);
        // console.log(touched);
    }, [isSubmitting]);

    const handlePreview = () => {
        setShowPreview(true); // Show the preview modal
    };

    const handleClosePreview = () => {
        setShowPreview(false); // Hide the preview modal
    };

    const addField = (fieldType) => {
        setFieldValue("newFieldType", fieldType);
        handleAddField();
    };

    const fetchAllSubCategory = async () => {
        setLoading(true);

        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllSubCategory",
        });
        const output = response.data;

        if (output.length > 0) {
            setsubCategories(
                output.map((option) => ({
                    value: option.pk_sub_cat_key,
                    label: option.subcat_name,
                    fk_cat_key: option.fk_cat_key
                }))
            );
        }
        setLoading(false);
    };
    // const StableEditor = React.memo(({ value, fieldName, setFieldValue, placeholder, error, touched, config }) => {
    //   const editorRef = useRef(null);
    //   const [localContent, setLocalContent] = useState(value || "");
    //   const lastValueRef = useRef(value);

    //   // Sync only if external value changes (not on typing)
    //   useEffect(() => {
    //     if (value !== lastValueRef.current) {
    //       setLocalContent(value || "");
    //       lastValueRef.current = value;
    //     }
    //   }, [value]);

    //   const handleChange = useCallback((newContent) => {
    //     setLocalContent(newContent);
    //     lastValueRef.current = newContent;
    //   }, []);

    //   const handleBlur = useCallback(() => {
    //     const cleanValue = localContent === "<p><br></p>" ? "" : localContent;
    //     setFieldValue(fieldName, cleanValue);
    //   }, [localContent, fieldName, setFieldValue]);

    //   return (
    //     <>
    //       <JoditEditor
    //         ref={editorRef}
    //         value={localContent}
    //         config={config}
    //         onChange={handleChange}
    //         onBlur={handleBlur}
    //         tabIndex={1}
    //         placeholder={placeholder}
    //       />
    //       {error && touched && <p className="text-danger">{error}</p>}
    //     </>
    //   );
    // });

    const handleContentChange = (e, content, index) => {
        const updatedFields = [...values.additionalFields];
        updatedFields[index].value = content === "<p><br></p>" ? "" : content;
        setFieldValue("additionalFields", updatedFields);
    }



    return (
        <div className="container mt-4 bg-white p-4 mb-3">
            <ToastContainer position="top-center" />
            <Form className="mb-3" onSubmit={handleSubmit} ref={formRef}>
                <Form.Group className="d-flex justify-content-between mb-3 flex-sm-wrap">
                    <h4 className="mb-2">Add New Article</h4>
                    <div>
                        <Button variant="outline-dark" className="me-2" onClick={handlePreview}>
                            Preview
                        </Button>

                        <Button variant="dark" type="submit" disabled={isSubmitting}>
                            Add Article
                            {isSubmitting && <LinearProgress />}
                        </Button>
                    </div>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Title <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control type="text" name="ac_name" value={values.ac_name} onChange={handleChange} onBlur={handleBlur} placeholder="Title" />
                    {errors.ac_name && touched.ac_name && <p className="text-danger">{errors.ac_name}</p>}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Summary <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control type="text" name="ac_summary" value={values.ac_summary} onChange={handleChange} onBlur={handleBlur} placeholder="Summary" />
                    {errors.ac_summary && touched.ac_summary && <p className="text-danger">{errors.ac_summary}</p>}
                </Form.Group>

                {/* Dynamic Created Inputs */}
                {values.additionalFields.map((field, index) => (
                    <Form.Group key={index} className="mb-3 position-relative z-1">
                        {field.isNew && (
                            <Button
                                variant="link"
                                onClick={() => handleRemoveField(index)}
                                className="position-absolute top-0 end-0 p-1"
                                style={{ zIndex: 1, backgroundColor: "transparent" }}
                            >
                                <span className="text-danger">×</span>
                            </Button>
                        )}

                        {field.type === "text" && (
                            <>
                                <Form.Label>
                                    Sub Title <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={field.value}
                                    // onChange={(e) => {
                                    //     const updatedFields = [...values.additionalFields];
                                    //     updatedFields[index].value = e.target.value;
                                    //     setFieldValue("additionalFields", updatedFields);
                                    // }}
                                    onChange={(e) => {
                                        setFieldValue(`additionalFields[${index}].value`, e.target.value);
                                    }}
                                    placeholder="Text Box"
                                    isInvalid={!!errors.additionalFields?.[index]?.value && !!touched.additionalFields?.[index]?.value}
                                />
                                {errors.additionalFields?.[index]?.value && touched.additionalFields?.[index]?.value && (
                                    <Form.Control.Feedback type="invalid">{errors.additionalFields[index].value}</Form.Control.Feedback>
                                )}
                            </>
                        )}

                        {field.type === "multimedia" && (
                            <>
                                <Form.Label>
                                    Content <span className="text-danger">*</span>
                                </Form.Label>
                                <JoditEditor
                                    ref={editor}
                                    config={EditorConfig}
                                    value={field.value}
                                    onChange={(e, content) => {
                                        handleContentChange(e, content, index)
                                    }}
                                    // onChange={(content) => {
                                    //     setFieldValue(`additionalFields[${index}].value`, content === "<p><br></p>" ? "" : content);
                                    // }}
                                    onBlur={(content) => {
                                        const updatedFields = [...values.additionalFields];
                                        updatedFields[index].value = content === "<p><br></p>" ? "" : content;
                                        setFieldValue("additionalFields", updatedFields);
                                    }}
                                    // value={formik.values.mail_content}
                                    // onChange={(value) => {
                                    //     formik.setFieldValue("mail_content", value);
                                    // }}
                                    // onBlur={(value) => {
                                    //     formik.setFieldValue("mail_content", value);
                                    // }}
                                    placeholder="Multimedia"
                                />
                                {errors.additionalFields?.[index]?.value && touched.additionalFields?.[index]?.value && (
                                    <p className="text-danger">{errors.additionalFields[index].value}</p>
                                )}
                            </>
                        )}

                        {field.type === "image/video" && (
                            <>
                                <Form.Label>
                                    Image/Video <span className="text-danger">*</span>
                                </Form.Label>
                                <label
                                    htmlFor={`additionalImage-${index}`}
                                    role="button"
                                    className="dropzone border p-4 rounded w-100 text-center"
                                    style={{ cursor: "pointer" }}
                                >
                                    <p>Drag 'n' drop an image or video here, or click to select one</p>

                                    {field.value &&
                                        (field.fileType ? (
                                            field.fileType.startsWith("image/") ? (
                                                <img src={field.value} alt="Additional" style={{ maxWidth: "100%", maxHeight: "200px", objectFit: "cover" }} />
                                            ) : field.fileType.startsWith("video/") ? (
                                                <video src={field.value} controls style={{ maxWidth: "100%", maxHeight: "200px" }} />
                                            ) : null
                                        ) : null)}
                                </label>
                                <input
                                    type="file"
                                    id={`additionalImage-${index}`}
                                    onChange={(e) => handleFileChange(e, index)}
                                    style={{ display: "none" }}
                                    accept={field.accept}
                                />
                                {errors.additionalFields?.[index]?.file ? <p className="text-danger">{errors.additionalFields[index].file}</p> : null}
                            </>
                        )}

                        {field.type === "subtitle" && <h5>{field.value}</h5>}
                    </Form.Group>
                ))}

                {/* Additional Fields Section */}
                <div className="mb-3">
                    <div className="d-flex justify-content-end align-items-center gap-2">
                        <Dropdown>
                            <Dropdown.Toggle variant="outline-dark" id="dropdown-basic">
                                {values.newFieldType
                                    ? `Add ${values.newFieldType.charAt(0).toUpperCase() + values.newFieldType.slice(1)}`
                                    : "+ Add More Fields"}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleAddField("text")}>Text Box</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleAddField("multimedia")}>Multimedia</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleAddField("image/video")}>Image/Video</Dropdown.Item>
                            </Dropdown.Menu>
                            {/* <Dropdown.Menu>
                                    <Dropdown.Item
                                        onClick={() => {
                                            // Add a new field type 'text' to additionalFields
                                            setFieldValue("newFieldType", "text");
                                        }}
                                    >
                                        Text Box
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => {
                                            // Add a new field type 'multimedia' to additionalFields
                                            setFieldValue("newFieldType", "multimedia");
                                        }}
                                    >
                                        Multimedia
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => {
                                            // Add a new field type 'image/video' to additionalFields
                                            setFieldValue("newFieldType", "image/video");
                                        }}
                                    >
                                        Image/Video
                                    </Dropdown.Item>
                                </Dropdown.Menu> */}
                        </Dropdown>
                        {/* <Button variant="outline-dark" onClick={handleAddField}>
                                Add Field
                            </Button> */}
                    </div>
                </div>
                <div className="mb-3 d-flex gap-2 flex-sm-wrap flex-md-nowrap">
                    <Form.Group controlId="status" className="w-50 w-sm-100">
                        <Form.Label>
                            Status <span className="text-danger">*</span>
                        </Form.Label>
                        <Select
                            options={statusOption}
                            id="status"
                            name="status"
                            value={statusOption.find((option) => option.value && values.status && option.value.toString() === values.status.toString())}
                            onChange={(selectedOption) => {
                                const event = {
                                    target: {
                                        name: "status",
                                        value: selectedOption["value"],
                                    },
                                };
                                handleChange(event);
                            }}
                            onBlur={(event) => {
                                handleBlur(event);
                                setTouched({ ...touched, status: true });
                            }}
                        />

                        {errors.status && touched.status && <p className="text-danger">{errors.status}</p>}
                    </Form.Group>
                    <Form.Group controlId="category" className="w-50 w-sm-100">
                        <Form.Label>
                            Category <span className="text-danger">*</span>{" "}
                        </Form.Label>
                        <Select
                            options={categoryOption}
                            id="category"
                            name="category"
                            value={categoryOption.filter((option) => values.category.includes(option.value))}
                            isMulti
                            onChange={(selectedOptions) => {
                                const event = {
                                    target: {
                                        name: "category",
                                        value: selectedOptions.map((option) => option.value), // Map to an array of selected values
                                    },
                                };
                                handleChange(event);
                            }}
                            onBlur={(event) => {
                                handleBlur(event);
                                setTouched({ ...touched, category: true });
                            }}
                        />

                        {errors.category && touched.category && <p className="text-danger">{errors.category}</p>}
                    </Form.Group>


                    <Form.Group controlId="fk_mag_key" className="w-50 w-sm-100">
                        <Form.Label>
                            Magazine <span className="text-danger">*</span>{" "}
                        </Form.Label>
                        <Select
                            options={magazineOption}
                            id="fk_mag_key"
                            name="fk_mag_key"
                            value={magazineOption.find(
                                (option) => option.value && values.fk_mag_key && option.value.toString() === values.fk_mag_key.toString()
                            )}
                            onChange={(selectedOption) => {
                                const event = {
                                    target: {
                                        name: "fk_mag_key",
                                        value: selectedOption["value"],
                                    },
                                };
                                handleChange(event);
                            }}
                            onBlur={(event) => {
                                handleBlur(event);
                                setTouched({ ...touched, fk_mag_key: true });
                            }}
                        />

                        {errors.fk_mag_key && touched.fk_mag_key && <p className="text-danger">{errors.fk_mag_key}</p>}
                    </Form.Group>
                </div>
                {values.category.length > 0 && (
                    <div className="mb-3">
                        {values.category.map((catId) => {
                            // Get category details
                            const category = categoryOption.find((c) => c.value === catId);

                            // Get only subcategories for this category
                            const subOptions = subcategories
                                .filter((s) => s.fk_cat_key === catId)
                                .map((s) => ({ label: s.label, value: s.value }));

                            // 👇 Skip rendering if no subcategory available
                            if (subOptions.length === 0) return null;

                            return (
                                <div
                                    key={catId}
                                    className="d-flex flex-column flex-md-row align-items-md-center mb-2"
                                >
                                    <Form.Label className="me-md-3 mb-1 mb-md-0" style={{ minWidth: "150px" }}>
                                        {category?.label || "Category"} — Subcategory
                                        {/* <span className="text-danger">*</span> */}
                                    </Form.Label>

                                    <div className="flex-grow-1">
                                        <Select
                                            options={subOptions}
                                            name={`subcategory-${catId}`}
                                            value={subOptions.find(
                                                (opt) => opt.value === values.subcategories?.[catId]
                                            )}
                                            onChange={(selectedOption) => {
                                                const event = {
                                                    target: {
                                                        name: "subcategories",
                                                        value: {
                                                            ...values.subcategories,
                                                            [catId]: selectedOption?.value || "",
                                                        },
                                                    },
                                                };
                                                handleChange(event);
                                            }}
                                            onBlur={() => {
                                                handleBlur({ target: { name: "subcategories" } });
                                                setTouched({ ...touched, subcategories: true });
                                            }}
                                        />
                                        {errors.subcategories &&
                                            touched.subcategories &&
                                            !values.subcategories?.[catId] && (
                                                <p className="text-danger mt-1 mb-0">
                                                    Please select a subcategory for {category?.label}.
                                                </p>
                                            )}
                                    </div>
                                </div>
                            );
                        })}

                        {/* Global error if validation fails */}
                        {errors.subcategories &&
                            touched.subcategories &&
                            typeof errors.subcategories === "string" && (
                                <p className="text-danger">{errors.subcategories}</p>
                            )}
                    </div>
                )}
                <div className="mb-3 d-flex gap-2">
                    <Form.Group controlId="newTag" className="w-50">
                        <Form.Label>
                            Tag <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            ref={newTagRef}
                            value={values.newTag}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Add a tag"
                            className="form-control border"
                        />
                        {errors.newTag && touched.newTag && <p className="text-danger">{errors.newTag}</p>}
                        {errors.tags && touched.tags && <p className="text-danger">{errors.tags}</p>}
                    </Form.Group>

                    <div className="w-50">
                        <Button
                            variant="outline-dark"
                            onClick={handleAddTag}
                            id="addTagBtn"
                            className="p-0 p-1"
                            style={{ fontSize: "14px", marginTop: "30px" }}
                            disabled={!!errors.newTag && touched.newTag}
                        >
                            Add Tag
                        </Button>
                    </div>
                </div>
                {values.tags.length > 0 && (
                    <div className="mb-3">
                        <h6>Tags:</h6>
                        {values.tags.map((tag) => (
                            // <span key={tag} className="badge bg-secondary me-2 position-relative" style={{ cursor: "pointer" }}>
                            //     {tag}
                            //     <span
                            //         className="position-absolute translate-middle"
                            //         style={{
                            //             color: "red",
                            //             top: "-3px",
                            //             end: "-3",
                            //             fontSize: "1rem",
                            //             cursor: "pointer",
                            //             padding: "0.2rem",
                            //             zIndex: 1,
                            //         }}
                            //         onClick={(e) => {
                            //             e.stopPropagation(); // Prevents triggering the parent onClick
                            //             handleRemoveTag(tag);
                            //         }}
                            //     >
                            //         ×
                            //     </span>
                            // </span>
                            <span key={tag} className="badge bg-secondary me-4 position-relative" style={{ cursor: "pointer" }}>
                                {tag}
                                <span
                                    className="position-absolute translate-middle"
                                    style={{
                                        color: "red",
                                        top: "7px",
                                        right: "-25px",
                                        fontSize: "1rem",
                                        cursor: "pointer",
                                        padding: "0.2rem",
                                        zIndex: 1,
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveTag(tag);
                                    }}
                                >
                                    ×
                                </span>
                            </span>
                        ))}
                    </div>
                    // <div className="mb-3">
                    //     <h6>Tags:</h6>
                    //     {values.tags.map((tag) => (
                    //         <span key={tag} className="badge bg-secondary me-2" style={{ cursor: "pointer" }}>
                    //             {tag}
                    //         </span>
                    //     ))}
                    // </div>
                )}
            </Form>

            {/* Preview Modal */}
            <Modal show={showPreview} onHide={handleClosePreview} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Article Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: "800px", overflowY: "scroll" }}>
                    <h1 className="text-center">{values.ac_name}</h1>
                    <h5>{values.ac_summary}</h5>

                    {values.additionalFields.map((field, index) => (
                        <div key={index} className="mt-3">
                            {field.type === "text" && <p>{field.value}</p>}
                            {field.type === "multimedia" && <div dangerouslySetInnerHTML={{ __html: field.value }} />}
                            {field.value &&
                                (field.fileType ? (
                                    field.fileType.startsWith("image/") ? (
                                        <div className="w-100 text-center">
                                            <img
                                                src={field.value}
                                                alt="Additional"
                                                style={{
                                                    maxWidth: "100%",
                                                    maxHeight: "200px",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        </div>
                                    ) : field.fileType.startsWith("video/") ? (
                                        <div className="w-100 text-center">
                                            <video
                                                src={field.value}
                                                controls
                                                style={{
                                                    maxWidth: "100%",
                                                    maxHeight: "200px",
                                                }}
                                            />
                                        </div>
                                    ) : null
                                ) : null)}
                            {field.type === "subtitle" && <h5>{field.value}</h5>}
                        </div>
                    ))}
                    {values.tags.length > 0 && (
                        <div className="mt-3">
                            <h6>Tags:</h6>
                            {values.tags.map((tag) => (
                                <span key={tag} className="badge bg-secondary me-2">
                                    {tag}
                                </span>
                            ))}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClosePreview}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AddArticleForm;
